module.exports = __webpack_public_path__ + "media/images/ALLCARE_ACADEMY_Banner_3-916bdd6550b404d4268b4bbad53ba864.jpg";